<template>
  <div class="row p-4">
    <div class="col-12 col-xl-7 px-4">
      <DocumentHeader :document="data" :documentId="documentId" :editable="editable" :bankAccounts="bankAccounts" @edit-data="editData" />
      <DocumentDetail :document="data" :editable="editable" :bankAccounts="bankAccounts" @update-document="handleDocUpdate" @file-changed="handleFileChanged" />
      <DocumentBudgets :documentId="documentId" v-if="$store.getters.hasPerm('view_budget')"/>
      <DocumentNotes :documentId="documentId" v-if="$store.getters.hasPerm('view_notefinances')"/>
    </div>
    <div class="col-12 col-xl-5 px-4">
      <embed v-if="$store.getters.hasPerm('view_documents') && documentPreview && previewType" :src="documentPreview" :type="previewType" class="preview">
    </div>
  </div>
</template>


<script>
import DocumentHeader from "@/components/DocumentHeader.vue";
import DocumentDetail from "@/components/DocumentDetail.vue";
import DocumentBudgets from "@/components/DocumentBudgets.vue";
import DocumentNotes from "@/components/DocumentNotes.vue";

export default {
  components: {
    DocumentHeader,
    DocumentDetail,
    DocumentBudgets,
    DocumentNotes,
  },
  data() {
    return {
      documentId: null,
      editable: false,
      data: {},
      documentFile: null,
      documentPreview: '',
      previewType: '',
      bankAccounts: [],
      bankAccountsOther: [],
    }
  },
  watch: {
    "$route.params.id": {
      handler: function (val) {
        if (val) {
          this.documentId = this.$route.params.id;
          this.loadData();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleDocUpdate({ where, property, newValue }) {
      switch (where) {
        case 'document_type':
          this.data.document_type[property] = newValue;
          break;
        case 'region':
          this.data.region[property] = newValue;
          break;
        case 'chapter':
          this.data.chapter[property] = newValue;
          break;
        case 'subchapter':
          this.data.subchapter[property] = newValue;
          break;
        case 'pay_to':
          this.data.pay_to[property] = newValue;
          break;
        case 'pay_from':
          this.data.payment_error = true; // We need to keep the document editable until it is saved, if it was already approved
          this.data.pay_from[property] = newValue;
          break;
        default:
          this.data[property] = newValue;
      }
    },
    editData(save) {
      if (this.editable && save === true) {
        if (!(this.documentFile || this.data.document)
            || Object.keys(this.data.document_type).length === 0
            || Object.keys(this.data.region).length === 0
            || !this.data.description
            || !this.data.amount
            || !((this.data.pay_to.account_number && this.data.pay_to.bank_number) || this.data.pay_to.iban)) {
          alert("Musíte zadat povinné údaje: doklad, typ dokladu, organizace, org. složka, popis plnění, částka, číslo účtu");
          return;
        }
        const numberPattern = /^\d*$/; // regex pattern for numbers only
        if ((this.data.vs && !numberPattern.test(this.data.vs))
            || (this.data.ks && !numberPattern.test(this.data.ks))
            || (this.data.ss && !numberPattern.test(this.data.ss))) {
          alert('VS, KS a SS mohou obsahovat pouze číselnou hodnotu');
          return
        }
        this.$store.getters.api.put("/finance/" + this.documentId, this.data)
          .then(function () {
            this.editable = false;
            this.data.payment_error = false;
            if (this.documentFile) {
              this.uploadDocToServer();
            }
          }.bind(this))
          .catch(function (error) {
            alert("Nepodařilo se uložit změny. Opakujte akci, nebo kontaktujte správce systému. Chyba: " + error.message);
          });
      } else if (this.editable) {
        this.editable = false;
        this.loadData();
      } else {
        this.editable = true;
      }
    },
    loadData: function () {
      this.$store.getters.api.get("/finance/accounts").then(response => {
        this.bankAccounts = [];
        const sorted = response.data.items.sort((a, b) => {
            if (a.name === null && b.name === null) {
                return 0;
            } else if (a.name === null) {
                return -1;
            } else if (b.name === null) {
                return 1;
            } else {
                return a.name.localeCompare(b.name);
            }
        }); // Sort accounts by name
        sorted.forEach((account) => {
          if (account.account_type === 'intern') {
            this.bankAccounts.push(account);
          } else {
            this.bankAccountsOther.push(account);
          }
        })
      });
      this.$store.getters.api.get("/finance/" + this.documentId).then(function (response) {
        this.data = response.data.items;
        if (this.data.document) {
          this.previewDoc();
        }
      }.bind(this));
    },
    handleFileChanged(newDocumentFile) {
      this.documentFile = newDocumentFile;
    },
    uploadDocToServer: function () {
      let formData = new FormData();
      formData.append('document', this.documentFile);
      this.$store.getters.api.post("/finance/" + this.data.id + "/document",
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(function () {
        this.data.document = true;
        this.previewDoc();
      }.bind(this));
    },
    previewDoc: function () {
      if (!this.$store.getters.hasPerm('view_documents')) {
        return;
      }

      this.$store.getters.api.get("/finance/" + this.documentId + "/document", {
        responseType: 'blob'
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // determine file extension from Content-Type header
        const contentType = response.headers['content-type'];
        this.previewType = contentType;

        // update documentPreview with the URL
        this.documentPreview = href;
      }).catch((error) => {
        console.error('Error downloading file:', error);
      });
    },
  }
}
</script>


<style scoped lang="scss">
@import "@/scss/abstracts/_variables.scss";

.preview {
  border: 1px solid grey;
  width: 100%;
  height: 85vh;
  object-fit: contain;
}

</style>
